import React from "react";
import TabbedPage from "../../../../shared/ui/TabbedPage";
import TargetsTab from "../../components/TargetsTab";

export default function TargetsPage() {
  return (
    <TabbedPage
      title="تنظیمات تارگت ها"
      defaultTab="target"
      tabs={[{ id: "target", label: "تارگت ها", component: TargetsTab }]}
    />
  );
}
